// @ts-nocheck
import { checkboxSizes } from "@insite/mobius/Checkbox";
import { toggleSizes } from "@store/MobiusOverrides/Checkbox/ToggleInput";
import merge from "lodash/merge";

/** checkboxSizes
 * ------------------------------------------------------------------------------------------
 * iconSize: Icon size (px)
 * fontSize: Font size for label (px)
 * borderRadius: Border radius (px)
 *  --- Starter Custom Code
 * borderWidth: Border size (px)
 * boxSpacing: Spacing between the checkbox and the label (px)
 * descriptionSpacing: Spacing between hint & error and field (px)
 * itemSpacing: Spacing inbetween checboxes of a same group (px)
 * offset: Offset to align the checkbox with the label (px)
 * toggleOffset: Offset to align the toggle checkbox with the label (px)
 */

merge(checkboxSizes, {
    default: {
        iconSize: 18,
        fontSize: 15,
        borderRadius: 3,
        // Starter Custom Code
        borderWidth: 2,
        boxSpacing: 9,
        descriptionSpacing: 7,
        itemSpacing: 10,
        offset: 2,
        toggleOffset: 2,
    },
    small: {
        iconSize: 16,
        fontSize: 14,
        borderRadius: 2,
        // Starter Custom Code
        borderWidth: 2,
        boxSpacing: 8,
        descriptionSpacing: 5,
        itemSpacing: 6,
        offset: 2,
        toggleOffset: 2,
    },
});

merge(toggleSizes, {
    default: {
        iconSize: 16,
        circleSize: 12,
        height: 20,
        width: 36,
        uncheckedOffset: -16,
    },
    small: {
        iconSize: 14,
        circleSize: 10,
        height: 16,
        width: 30,
        uncheckedOffset: -15,
    },
});
